import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  marketTotalHeaderNomination: {
    color: '#ffffff',
  },
  decimelStyle: {
    fontSize: 32,
  },
  currencyStyle: {
    fontSize: 24,
  }
})
